import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Layout from "./components/Navigation/layout";
import HomePage from "./pages/Homepage";
import LandingPage from "./pages/LandingPage";

// Moda Transportasi
import DataLRT from "./pages/Moda_Transportasi/Data_LRT";
import DataAgregatPenumpang from "./pages/Moda_Transportasi/Data_AgregatPenumpang";
import DataJaklingko from "./pages/Moda_Transportasi/Data_Jaklingko";
import MRTPage from "./pages/Moda_Transportasi/Data_MRT";
import DataPLIS from "./pages/Moda_Transportasi/Data_PLIS";
import DataTransjakarta from "./pages/Moda_Transportasi/Data_Transjakarta";
import DataKLG from "./pages/Moda_Transportasi/Data_KLG";
import DataUPAP from "./pages/Moda_Transportasi/Data_UPAP";
import DataUPAS from "./pages/Moda_Transportasi/Data_UPAS";
import DataMutis2026 from "./pages/Moda_Transportasi/Data_Mutis2026";
import RingkasanEksekutifTJ from "./pages/Moda_Transportasi/Data_RingkasanEksekutif_Transjakarta";

// Data Penertiban Dalops
import Penertiban from "./pages/Penertiban";

// Lalu Lintas
import JumlahKendBermotor from "./pages/Lalu_Lintas/Jumlah_KendBermotor";
import VolLalinDalkot from "./pages/Lalu_Lintas/Volume_LalinDalkot";
import VolLalinPerbatasan from "./pages/Lalu_Lintas/Volume_LalinPerbatasan";
// Terminal
import DataPenumpangTerminal from "./pages/Terminal/Data_penumpangTerminal";
import PetaLokasi from "./pages/Terminal/PetaLokasi";
//Logistik
import BongkarMuat from "./pages/Logistik/BongkarMuat";
import Komoditas from "./pages/Logistik/Komoditas";
// Angkutan Musiman
import AngkutanLebaran from "./pages/Angkutan_Musiman/Angkutan_Lebaran";
import AngkutanNataru from "./pages/Angkutan_Musiman/Angkutan_Nataru";

// Parkir
import DataParkirOffStreet from "./pages/Parkir/Data_Perparkiran";

// Pengujian
import DataKIR from "./pages/Pengujian_Kendaraan/Data_KIR";


function App() {
  return (
    <BrowserRouter>
      <Routes> 
        {/* ==== HomePage ==== */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/beranda" element={<Layout><HomePage /></Layout>} />
       
        {/* ==== Moda Transportasi ==== */}
        <Route path="/dataUPAP" element={<Layout><DataUPAP/></Layout>} />
        <Route path="/dataUPAS" element={<Layout><DataUPAS/></Layout>} />
        <Route path="/dataMRT" element={<Layout><MRTPage/></Layout>} />
        <Route path="/dataLRT" element={<Layout><DataLRT/></Layout>} />
        <Route path="/dataKLG" element={<Layout><DataKLG/></Layout>} />
        <Route path="/dataTransjakarta" element={<Layout><DataTransjakarta/></Layout>} />
        <Route path="/RingkasanEksekutifTJ" element={<Layout><RingkasanEksekutifTJ/></Layout>} />
        <Route path="/dataJaklingko" element={<Layout><DataJaklingko/></Layout>} />
        <Route path="/dataPLIS" element={<Layout><DataPLIS/></Layout>} />
        <Route path="/dataAgregatPenumpang" element={<Layout><DataAgregatPenumpang/></Layout>} />
        <Route path="/mutis2026" element={<Layout><DataMutis2026/></Layout>} />
        
        {/* Penertiban/Penindakan Dalops */}
        <Route path="/penindakandalops" element={<Layout><Penertiban/></Layout>} />

        {/* Penertiban/Penindakan Dalops */}
        <Route path="/dataParkir"element={<Layout><DataParkirOffStreet/></Layout>} />

        {/* ==== Lalu Lintas ==== */}
        <Route path="/volLalinDalamKota" element={<Layout><VolLalinDalkot/></Layout>} />
        <Route path="/volLaluLintas" element={<Layout><VolLalinPerbatasan/></Layout>} />
        <Route path="/jumlahKendaraanBermotor" element={<Layout><JumlahKendBermotor/></Layout>} />
        
        {/* ==== Terminal ==== */}
        <Route path="/dataPenumpangTerminal" element={<Layout><DataPenumpangTerminal/></Layout>} />
        <Route path="/petaLokasi" element={<Layout><PetaLokasi/></Layout>} />

        {/* ==== Logistik ==== */}
        <Route path="/bongkarmuat" element={<Layout><BongkarMuat/></Layout>} />
        <Route path="/komoditas" element={<Layout><Komoditas/></Layout>} />

        {/* ==== Angkutan Musiman ==== */}
        <Route path="/angkutanNataru" element={<Layout><AngkutanNataru/></Layout>} />
        <Route path="/angkutanLebaran" element={<Layout><AngkutanLebaran/></Layout>} />
        
        {/* ==== Pengujian Kendaraan ==== */}
        <Route path="/pengujian" element={<Layout><DataKIR/></Layout>} />

        {/* 404 fallback */}
        <Route path="*" element={<div>Halaman tidak ditemukan</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
